import SpecialClassForm from "@/components/teacher/special-class/SpecialClassForm";

export default function SpecialClassFormPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-form-blue text-white py-6 shadow-md">
        <div className="container max-w-4xl mx-auto px-4">
          <h1 className="text-2xl md:text-3xl font-bold">แบบฟอร์มคลาสเฉพาะกิจ</h1>
          <p className="mt-2 text-blue-100">กรุณากรอกข้อมูลให้ครบถ้วน เพื่อความถูกต้องในการประเมินคลาสการสอน</p>
        </div>
      </header>

      <main className="container max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
          <SpecialClassForm />
        </div>
      </main>
    </div>
  );
}